export enum Priority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high'
}

export type PriorityType = 'low' | 'medium' | 'high';

export const isPriorityValid = (value: string | null | undefined): value is PriorityType => {
  if (!value) return false;
  return Object.values(Priority).includes(value as Priority);
};
